import axios from "axios";
import { atom, selector } from 'recoil';
import { setRecoil, getRecoil } from "recoil-nexus";
import { sortBy  } from 'lodash';
import { authentication } from '../services';
import { marketCode, marketCodeList, defCountryCode } from './marketcode';
import { defaultLang, languagesList } from './language';
import { appPermission , currentEnvironment, environmentList, userGroupsCode, ApplicationListData} from './permissions';
import { AppEnv, Auth, GenericApiBaseURL } from '../environment';
import API from '../Pages/API-Services';
import { FilterGroupAtom } from './global';

const LoginState = atom({
  key:'loginState',
  default: true
});

const authenticate = atom({
  key: 'authenticate',
  default: null,
});

const getLoginToken = selector({
  key: 'appToken',
  get: async () => {
      let response;
      // If local env then set user token via enviroment file
      if( AppEnv === 'local') {
        response = Auth;
      } else {
        // call ADMIN API
        response = await authentication.getTokenAsync();
      }
      return response;
  },
  set: ({ set }, newValue) => set(authenticate, newValue)

});

const userLoginLog = selector({
  key: 'userLoginLog',
  get: async () => {
    let loginUser = getRecoil(authenticate);
    let { firstName, lastName, email } = loginUser || {};
    let user = {
      applicationName: 'FXHUB',
      firstName,
      lastName,
      email 
    }
    return await authentication.userlog(user);
  },

});

const getUserGroups = async () => {
  try {
    const response = await axios.get(`${GenericApiBaseURL}/getUserGroups-ipad`);;
    return response;
  } catch (e) {
    console.error('Error during getUserGroups-ipad:', e.toString());
  }
};

const AuthorizationAPI = async (authenticate) => {
  let interroList = [];
  const auth = authenticate;
  let env = auth && auth.env;
  const allowedGroups = ["interro","AZ_HCM_US_UI_DASHBOARD","XAZ-OBU-Orion-HQ","OBU-Orion-HQ","OBU-Orion-BC-OBM","OBU-Orion-LC-OBM","OBU-Orion-BC-OAD","OBU-Orion-LC-OAD","OBU-Orion-BC-OAS","OBU-Orion-LC-OAS","OBU_Test_PelicanReporting_Breast","OBU_Test_PelicanReporting_Lung","+OBUPelicanL3-FH-BC","+OBUPelicanL3-FH-GI","+OBUPelicanL3-FH-GYNGU","+OBUPelicanL3-FH-HEM","+OBUPelicanL3-FH-LC","+OBUPelicanL3-HQ","+OBUPelicanL3-HQTest","+OBUPelicanL3-OAD","+OBUPelicanL3-OAS","+OBUPelicanL3-OBM","+US MyInsights COE","+US MyInsights FTE","ADD","OBUPelican-CM-BP","OBUPelican-P2PLeads","OBUPelican-SP-HQ","OBUPelicanL2-Viewer","OBUPelicanL3-Coaching-Superusers","OBUPelicanL3-NS-Director","OBUPelicanL3-NS-Manager","OBUPelicanL3-RML","XAZ-OBU-Reporting-ADORA","XAZ-OBUPelicanL3-FH","XAZ-OBUPelicanL3-FH-OFAM","XAZ-OBUPelicanL3-Leadership","XAZ_AZAP_NA_PROD_COACH_OBUPelican","XAZ_AZAP_NA_PROD_NOAD_OBUPelican","XAZ_AZAP_NA_TEST_NAPelican","OBU-Orion-G2-OAS","OBU-Orion-G2-OBM","OBU-Orion-G2-OAD","OBUPelicanL3-OAD","OBUPelicanL3-OBM","ONC_BC_MGR","ONC_LC_MGR","ONC_LC_A","ONC_LC_N","ONC_LC_Z","ONC_BC_A","ONC_BC_N","ONC_BC_Z","OBU_PelicanReporting_Breast","OBU_PelicanReporting_Lung","ONC_HEM","ONC_GYN_GU","ONC_GI","OBU-Orion-GI-OAS","OBU-Orion-HEME-OAS","OBU-Orion-GI-OBM","OBU-Orion-HEME-OBM","OBU-Orion-GI-OAD","OBU-Orion-HEME-OAD"];
  if (['prod', 'uat', 'test'].includes(env)) {
    const res = await getUserGroups();
    if (res?.data?.responseListObject) {
      interroList = res?.data?.responseListObject.filter(item => allowedGroups.some(adgroup => item.includes(adgroup)));
    }
  }
  const response = await authentication.getPermission(authenticate, interroList);
  if (response) {
    setAuthAccess(response);
  }
  return response;
}

const generateEnvList = (environmentPermissionMap) => {
  let list = {};
    for ( let key in environmentPermissionMap) {
        let _key  = (key && key.toLowerCase());
        if( _key ) {
          list[_key] = environmentPermissionMap[key];
        }
    }
    return list;
}

const setAuthAccess = ({ defaultMarketCode, userApplicationDataList, marketCodeListing, defaultLangCode, allLangCodes, environmentPermissionMap, validGroups, countryCode }) => {
  if( validGroups) {
    let GROUP = validGroups.split(',')
    setRecoil(userGroupsCode,GROUP )
  }
  if (defaultMarketCode) {
    const code = getRecoil(marketCode);
    let isValid = marketCodeListing &&  marketCodeListing.includes(code);
    let default_code = isValid ? code : defaultMarketCode;
    setRecoil(marketCode, default_code);
  }
  if (marketCodeListing) {
    let list = sortBy(marketCodeListing)
    setRecoil(marketCodeList, list);
  }
  if (defaultLangCode) {
    setRecoil(defaultLang, defaultLangCode);
  }

  if (allLangCodes) {
    setRecoil(languagesList, allLangCodes);
  }

  if (countryCode) {
    setRecoil(defCountryCode, countryCode);
  }
 

  if( environmentPermissionMap && typeof environmentPermissionMap === 'object') {
    let list = generateEnvList(environmentPermissionMap) || {};
    const auth = getRecoil(authenticate);
    let env = auth && auth.env;
    let appList = list[env];
    
    if ( userApplicationDataList) {
      let regionsFilters = API.httpService.uniqByRegion(userApplicationDataList);
      setRecoil(ApplicationListData, userApplicationDataList);
      setRecoil(FilterGroupAtom, regionsFilters)
    }

    // set env list
    if( env ) {
      setRecoil(environmentList, list);
    }
    if( env) {
      setRecoil(currentEnvironment, env);
      let new_env = env === 'poc' ? 'dev' : env;
      setRecoil(appPermission, (list[new_env] || []));
    }
    setRecoil(LoginState, false);
  }

}

export { getLoginToken, authenticate, AuthorizationAPI, LoginState, userLoginLog};